import { Divider, Skeleton, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { Alert, api, getQueryProps } from 'common';

import { useFlowDefinitionContext } from '../../../../context';
import { BlockValueTemplateFieldArea } from '../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../ConfigFields/Duration';
import { BlockSelectField } from '../../ConfigFields/SelectField';

const { DurationUnits } = api.FlowDefinition;

export function Hl7FormFields() {
  const { flowDefinition } = useFlowDefinitionContext();
  const { organizationId } = flowDefinition;

  const {
    data: organization,
    isLoading,
    error,
  } = useQuery({
    ...getQueryProps(api.client.Organization, 'findOneById', organizationId),
  });

  const notEnabledAlert = (
    <Alert variant="warning">HL7 is not enabled for this practice and organization.</Alert>
  );

  if (isLoading) {
    return <Skeleton />;
  }
  if (error || !organization) {
    return notEnabledAlert;
  }

  let datastorePaths =
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    api.FlowDefinition.DEPRECATED_HARD_CODED_ORGANIZATION_IDS_TO_DATA_STORE_PATHS[
      flowDefinition.organizationId
    ];
  if (datastorePaths === undefined) {
    /**
     * FIXME - This check will be removed with the customer agnostic routing implementation
     * PRD: https://docs.google.com/document/d/10Ed0G7v-Nfb4Ach-OR5LspA1dgHAMT_aRY1Iaj8oQ68/edit?tab=t.0#heading=h.cd65rewounfq
     * Ticket: https://app.asana.com/0/1209009995423076/1209094266853167
     */
    const orgName = organization.name.toLowerCase();
    if (!orgName.includes('krieger') && !orgName.includes('e2e notable test')) {
      return notEnabledAlert;
    }
    datastorePaths = {
      [api.FlowDefinition.DatastoreInstanceType.NON_PRODUCTION]: `test-health-krieger-hl7`,
      [api.FlowDefinition.DatastoreInstanceType.PRODUCTION]: `prod-health-krieger-hl7`,
    };
  }

  return (
    <>
      <Stack direction="column" spacing={2}>
        <BlockSelectField
          fieldName="config.destinationDatastore"
          label="Destination Datastore"
          helperText="Datastore instance to send the message to"
          options={Object.entries(datastorePaths).map(([label, value]) => ({
            label,
            value,
          }))}
          required
        />
        <BlockDurationField
          fieldName="config.timeout"
          unitFieldNameSuffix="units"
          required={true}
          allowedUnits={[DurationUnits.Hours, DurationUnits.Minutes, DurationUnits.Seconds]}
          toggleLabel="Timeout"
          valueLabel="Timeout (fail after duration)"
          valueHelperText="Will fail if block does not get ack message after duration"
        />
        <Divider />

        <BlockValueTemplateFieldArea
          fieldName="config.message"
          label="HL7 Message"
          helperText="Enter the HL7 message content"
          required
        />
      </Stack>
    </>
  );
}
